import { dialogStyles } from './style.dialog.js';
import { trace } from '@nopeer';

export class nineDialog extends HTMLElement
{
	#shift;
	#dialog;

	constructor () {
		super();
	}

	connectedCallback() {

		const v = this.innerHTML;
		const titleText = this.getAttribute("subject") || "Details";

		trace.log(dialogStyles);

		this.innerHTML = `
			<style>${dialogStyles}</style>
		
			<dialog>
				<div class="head">
					<div class="rect1"></div>
					<div class="rect2"></div>
					<div class="rect3"></div>
					<ng-sphere class="icon" end-fill="#666" size="8"></ng-sphere>
					<span class="title">${titleText}</span>
					<span class="sub-title"></span>
					<div class="buttons">
						<ng-sphere class="apply" start-fill="#cc6" end-fill="#660" size="16" title="apply"></ng-sphere>
						<ng-sphere class="reset" start-fill="#99f" end-fill="#00f" size="16" title="reset"></ng-sphere>
						<ng-sphere class="close" start-fill="#f99" end-fill="#f00" size="16" title="close"></ng-sphere>
					</div>
				</div>
				<div class="contents">
					<div class="left">
						<span>가나다라마바사아자차카타파하가나다라마바사아자차카타파하가나다라마바사아자차카타파하가나다라마바사아자차카타파하가나다라마바사아자차카타파하가나다라마바사아자차카타파하가나다라마바사아자차카타파하가나다라마바사아자차카타파하</span>
					</div>
					<div class="body">
						${v}
					</div>
					<div class="close2">
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
							<path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
						</svg>
					</div>
				</div>
			</dialog>
		`;

		//this.#owner = this.getRootNode().host.closest("nine-grid");

		//$(".title", this).html("Details");

		this.#dialog = this.querySelector('dialog');
		this.#init();
	};

	showModal = () => {
		this.#dialog.showModal();

		(this.shadowRoot?.activeElement || document.activeElement)?.blur();
	};

	close = () => {
		// 이벤트 리스너 제거 (표준 방식은 핸들러 참조가 필요하지만,
		// 여기서는 요소가 사라지므로 메모리 관리를 위해 정리)
		this.#dialog.close();
		this.remove();
	};

	#init = () => {
		const head = this.querySelector('.head');

		if (head) {
			head.addEventListener('mousedown', this.#onMouseDown);
			head.addEventListener('touchstart', this.#onTouchStart);

			// 마우스 커서를 드래그 가능 아이콘(이동 십자가) 모양으로 변경하여 UX 개선
			//head.style.cursor = 'move';
		}

		// 1. 모든 닫기 성격의 버튼 (.close, .close2, .cancel) 공통 처리
		this.querySelectorAll('.close, .close2, .cancel').forEach(btn => {
			btn.onclick = () => this.closeWithAnimation(null); // 취소/닫기는 null 리턴
		});

		// 2. 확인 버튼 (.ok) 처리
		// 확인 버튼은 텍스트 입력값 등 데이터가 필요하므로
		// 실제 데이터 추출은 각 팝업 클래스(prompt 등)에서 하되,
		// 닫기 애니메이션 실행은 여기서 담당하도록 가이드합니다.
		this.querySelectorAll('.ok').forEach(btn => {
			// .ok 버튼의 로직은 각 팝업의 setupEvents에서 덮어쓰거나
			// 델리게이트 이벤트를 통해 처리합니다.
		});

		// 드래그 로직 생략...
	};

	// --- 드래그 로직 (Vanilla JS) ---
	#onMouseDown = e => {

		if (e.target.closest("buttons")) return;
		if (e.button !== 0 || e.altKey || e.ctrlKey || e.shiftKey) return;

		const rect = this.#dialog.getBoundingClientRect();
		this.#shift = {
			x: e.clientX - rect.left,
			y: e.clientY - rect.top
		};

		const onMouseMove = (ev) => {
			this.#dialog.style.position = 'fixed';
			this.#dialog.style.margin = '0';
			this.#dialog.style.left = `${ev.clientX - this.#shift.x}px`;
			this.#dialog.style.top = `${ev.clientY - this.#shift.y}px`;
		};

		const onMouseUp = () => {
			document.removeEventListener('mousemove', onMouseMove);
			document.removeEventListener('mouseup', onMouseUp);
		};

		document.addEventListener('mousemove', onMouseMove);
		document.addEventListener('mouseup', onMouseUp);
	};

	#onTouchStart = e => {
		if (e.target.closest("buttons")) return;

		const rect = this.#dialog.getBoundingClientRect();
		const touch = e.changedTouches[0];
		this.#shift = {
			x: touch.pageX - rect.left,
			y: touch.pageY - rect.top
		};

		const onTouchMove = (ev) => {
			const t = ev.changedTouches[0];
			this.#dialog.style.position = 'fixed';
			this.#dialog.style.margin = '0';
			this.#dialog.style.left = `${t.pageX - this.#shift.x}px`;
			this.#dialog.style.top = `${t.pageY - this.#shift.y}px`;
		};

		const onTouchEnd = () => {
			document.removeEventListener('touchmove', onTouchMove);
			document.removeEventListener('touchend', onTouchEnd);
		};

		document.addEventListener('touchmove', onTouchMove);
		document.addEventListener('touchend', onTouchEnd);
	};

	closeWithAnimation(returnValue) {
		this.#dialog.classList.add("out"); // 퇴장 애니메이션 시작

		// 애니메이션(0.3s)이 끝난 후 제거 및 이벤트 발생
		setTimeout(() => {
			this.#dialog.close();
			// 부모(BasePopup)에게 작업 완료와 결과값을 알림
			this.dispatchEvent(new CustomEvent('closed', { detail: returnValue }));
			this.remove();
		}, 300);
	}
}

// BasePopup.js
export class BasePopup extends HTMLElement {

	constructor() {
		super();
		this.attachShadow({ mode: 'open' });
	}

	static async open(PopupClass, message, title, options, renderFn) {
		// 1. 설정 병합
		const tagName = PopupClass.tagName.toLowerCase();
		const config = {
			"true-text": "확인",
			"false-text": "취소",
			class: "classic",
			animation: "fade",
			...(window.nine?.config?.ux?.[tagName.replace('nine-', '').replace('-popup', '')] || {}),
			...options
		};

		// 2. 중복 제거 및 엘리먼트 생성
		document.querySelectorAll(tagName).forEach(el => el.remove());
		const el = document.createElement(tagName);
		if (config.class) el.classList.add(config.class);
		if (config.animation) el.classList.add(config.animation);
		document.body.appendChild(el);

		// 3. 렌더링 (각 팝업의 UI 그리기)
		renderFn(el, message, config);

		const dialogComp = el.shadowRoot.querySelector("nine-dialog");
		if (title) dialogComp.setAttribute("subject", title);

		return new Promise((resolve) => {
			// [중요] nine-dialog의 애니메이션이 끝난 후 던지는 이벤트를 수신
			dialogComp.addEventListener('closed', (e) => resolve(e.detail));

			// 각 팝업 클래스에서 버튼 클릭 시 dialogComp.closeWithAnimation(값)을
			// 호출하도록 이벤트를 바인딩해줌
			el.setupEvents(resolve, dialogComp);

			dialogComp.showModal();
		});
	}
}

if (!customElements.get('nine-dialog')) {
	customElements.define("nine-dialog", nineDialog);
}
